import { types } from '../types/types';

const initialState ={
    msgError: null
}

export const msgReducer = (state = initialState, action ) => {
    switch ( action.type ) {
        case types.msgSetError:
            return { msgError: action.payload }
            
        case types.msgRemoveError: 
            return { msgError: null }
     
        default:
            return state;
    }
}